import {
  BackgroundSettingsV1,
  CameraSettingsV1,
  CharacterSettingsV1,
  LabelSettingsV1,
  PlaybackSettingsV1,
  SceneSettings,
} from '../types';
import apiRequest from './apiRequest';

export type SceneSettingsPayload = {
  backgroundSettings?: BackgroundSettingsV1;
  cameraSettings?: CameraSettingsV1;
  characterSettings?: CharacterSettingsV1;
  labelSettings?: LabelSettingsV1;
  playbackSettings?: PlaybackSettingsV1;
};

export type CreateSceneMotionInput = {
  motionID: string;
  variationNumber?: number;
  outputNumber?: number;
  title?: string;
};

export type CreateSceneRequest = {
  sceneName: string;
  motions: CreateSceneMotionInput[];
  sceneSettings?: SceneSettingsPayload;
  sceneSettingsID?: string;
  type?: 'MOTION';
  createdByUser?: string;
};

export type SceneResponse = {
  sceneID: string;
  sceneName: string;
  sceneSettings?: SceneSettings;
  sceneSettingsID?: string;
  type: 'MOTION';
  objects?: Record<string, unknown>;
  objectCount?: Record<string, number>;
  pendingJobs?: string[];
  createdAt?: string;
  createdBy?: string;
};

export default async function postExternalScene(apiKey: string, sceneRequest: CreateSceneRequest) {
  return await apiRequest<SceneResponse>('external-mogen', '/scenes', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': apiKey,
    },
    body: JSON.stringify(sceneRequest),
  });
}
